const HOST = process.env.VUE_APP_GATEWAY

// 当前后端不在同一个服务器时，需要指定host地址
// combine为true时五合一部署, 为false时分五个服务部署
const combine = false

const serviceMap = {
  form: process.env.VUE_APP_FORM_SERVICE_ALIAS,
  portal: process.env.VUE_APP_PORTAL_SERVICE_ALIAS,
  bpmRunTime: process.env.VUE_APP_RUNTIME_SERVICE_ALIAS,
  bpmModel: process.env.VUE_APP_MODEL_SERVICE_ALIAS,
  uc: process.env.VUE_APP_UC_SERVICE_ALIAS,
}

function getModuleRootUrl(module) {
  if (!combine) {
    const modulePath = serviceMap[module]
    return HOST + '/' + modulePath
  } else {
    // 默认是全部服务合一的端口
    const modulePort = '8088'
    return HOST + ':' + modulePort
  }
}
window.getModuleRootUrl = getModuleRootUrl
window.context = {
  manage: process.env.VUE_APP_MANAGE_URL, //管理端页面
  front: process.env.VUE_APP_FRONT_URL, //前端页面
  mobile: process.env.VUE_APP_MOBILE_URL, //手机端页面
  form: getModuleRootUrl('form'),
  portal: process.env.VUE_APP_PORTAL_URL || getModuleRootUrl('portal'),
  bpmRunTime: getModuleRootUrl('bpmRunTime'),
  bpmModel: getModuleRootUrl('bpmModel'),
  uc: getModuleRootUrl('uc'),
  gatewayUrl: HOST, //网关
}
